var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 14,
    cy: 46,
    r: 14,
    fill: "#94D8ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.664 35.824a6.956 6.956 0 005.317 1.5 27.933 27.933 0 006.859-2.39 9.965 9.965 0 017.098-.703M39.424 49.612c.65.14 1.32.166 1.98.08a9.94 9.94 0 002.393-.797 94.053 94.053 0 019.437-2.656l1.463-.438a.824.824 0 00.491-.306c.02-.11 0-.331 0-.331v-.558c.052-.98-1.307-1.337-2.688-1.448M33.5 49.822c.671.167 1.36.27 2.055.308.652.06 1.31.001 1.94-.173.846-.305 1.65-.716 2.393-1.221 3.882-2.324 7.976-3.041 11.817-5.445a.517.517 0 00.213-.199.503.503 0 000-.239 1.751 1.751 0 00-.93-1.328c-1.19-.743-2.588-.531-3.988-.221",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.96 49.701a14.617 14.617 0 004.465.53 6.65 6.65 0 002.02-.344 10.726 10.726 0 002.3-1.328c2.897-2.019 6.088-3.16 9.132-4.847l1.435-.784a.904.904 0 00.439-.424.821.821 0 000-.359l-.067-.598c-.169-1.498-3.026-1.034-4.685-.633",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.64 45.358a26.505 26.505 0 015.316-2.854c1.103-.425 2.26-.757 3.416-1.076 1.157-.319 6.713-1.673 6.34.85-.186 1.235-2.977 1.819-3.907 2.244l-5.69 2.576c-2.897 1.328-5.13 3.24-8.427 2.762a36.98 36.98 0 01-10.035-2.974M13.304 39.98a3.056 3.056 0 002.366 1.09c1.183 0 2.233-.532 3.376-.505 2.22 0 3.483 1.62 5.025 3",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.812 20.664H30.638c-.734 0-1.33.595-1.33 1.328v2.656c0 .733.596 1.328 1.33 1.328h17.174c.734 0 1.329-.595 1.329-1.328v-2.656c0-.733-.595-1.328-1.33-1.328z",
    fill: "#95D8ED",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.295 20.664v5.312M45.389 20.664v5.312M45.151 35.27H27.978c-.734 0-1.33.595-1.33 1.329v2.655c0 .734.596 1.328 1.33 1.328H45.15c.734 0 1.33-.594 1.33-1.328V36.6c0-.734-.596-1.328-1.33-1.328zM30.637 35.27v5.312M33.295 35.27v5.312M42.73 35.27v5.312",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.493 29.96H25.32c-.734 0-1.329.594-1.329 1.327v2.656c0 .733.595 1.328 1.33 1.328h17.173c.734 0 1.33-.595 1.33-1.328v-2.656c0-.733-.596-1.328-1.33-1.328zM27.979 29.96v5.31M39.414 29.96v5.31M35.754 29.96v5.31",
    stroke: "#24557C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 17v-4M37 17V8M40 17v-4",
    stroke: "#25557B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.3ee4929155ce6b4ca020bcccc4ccd8f0.svg";
export { ForwardRef as ReactComponent };